import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslationService } from 'projects/dop-core/src/public-api';
import { AttachDocumentService } from '../../data-service/attach-document.service';
import { AttachDocument } from '../../models/attach-document';
import { StringFormatter } from '../../pipes/string-formatter.pipe';

@Component({
  selector: 'app-delete-attachment-dialog',
  templateUrl: './delete-attachment-dialog.component.html',
  styleUrls: ['./delete-attachment-dialog.component.scss']
})
export class DeleteAttachmentDialogComponent implements OnChanges {

  constructor(
    private attachDocumentService: AttachDocumentService) {}

  @Input() openDialog: boolean;
  @Input() attachedDocuments: AttachDocument[];
  @Input() orderReference: string;

  @Output() openDialogChange: EventEmitter<boolean> = new EventEmitter();
  @Output() delete: EventEmitter<boolean> = new EventEmitter();

  // add translation
  message: string;
  modalHeader: string;

  async onDelete() {
    // API call to delete file
    const fileNamesToDelete = this.attachedDocuments.map(x => x.internalFileName);
    await this.attachDocumentService.deleteAttachment(this.orderReference, fileNamesToDelete).toPromise();
    this.openDialog = false;
    this.openDialogChange.next(this.openDialog);
    this.delete.next();
  }

  onCancel() {
    if (this.openDialog) {
      this.openDialog = false;
      this.openDialogChange.next(this.openDialog);
    }
  }

  ngOnChanges() {
    if (this.attachedDocuments.length === 1) {
      this.modalHeader = TranslationService.translate('vbeiDeleteSingleAttachmentHeader');
      this.message = StringFormatter
        .format(TranslationService.translate('vbeiDeleteSingleAttachmentMessage'), this.attachedDocuments[0].name);
    } else {
      this.modalHeader = TranslationService.translate('vbeiDeleteAllAttachmentHeader');
      this.message = TranslationService.translate('vbeiDeleteAllAttachmentMessage');
    }
  }
}
